<template>
  <v-dialog
    v-model="dialog"
    max-width="700"
    :fullscreen="isMobile()"
    scrollable
  >
    <v-card>
      <toolbar-card-visita :opcao_checklist="checklist" />
      <v-card-text class="pt-5">
        <slider-imagens-visita :imagens="pennStateImagens" categoria="pennstate" />

        <v-row class="mt-1">
          <v-col cols="12">
            <v-card flat color="grey lighten-4">
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <v-btn
                      block
                      text
                      color="primary"
                      @click="
                        $router.push({
                          path: `${$route.path}/pesagens-peneiras`,
                        })
                      "
                      ><v-icon left>mdi-scale</v-icon>Registrar pesagem</v-btn
                    >
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="12">
                    <pesagens-registradas-penn-state />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row class="mt-4">
          <v-col cols="12">
            <v-textarea
              rows="5"
              outlined
              persistent-placeholder
              label="Observações Penn State"
              placeholder="Ex.: partículas muito grandes ou finas, excesso de pó, ingredientes separados."
              v-model="visita.obs_penn_state"
              auto-grow
            ></v-textarea>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <btn-salvar-dados-visita />
          </v-col>
        </v-row>

        <router-view></router-view>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import BtnSalvarDadosVisita from "./BtnSalvarDadosVisita.vue";
import ToolbarCardVisita from "./ToolbarCardVisita.vue";
import SliderImagensVisita from "./SliderImagensVisita.vue";
import PesagensRegistradasPennState from "./PesagensRegistradasPennState.vue";
import { mapState } from "vuex";
export default {
  components: {
    ToolbarCardVisita,
    BtnSalvarDadosVisita,
    SliderImagensVisita,
    PesagensRegistradasPennState,
  },
  watch: {
    dialog: function (open) {
      if (!open) {
        this.$router.go(-1);
      }
    },
  },
  computed: {
    ...mapState("visitaTecnica", ["visita"]),
  },
  data: () => ({
    dialog: false,
    checklist: {
      descricao: "Penn State",
      icone: "mdi-filter-variant",
    },
    pennStateImagens: [
      {
        img: "https://rehagro.com.br/blog/wp-content/uploads/2024/02/capa-penn-state.jpg.webp",
      },
      {
        img: "https://www.educapoint.com.br/v2/v2/img/noticia/1105",
      },
      {
        img: "https://www.milkpoint.com.br/img/artigo/79271/?w=1200&h=630&cf=1&vs=23072020102057",
      },
      {
        img: "https://rehagro.com.br/blog/wp-content/uploads/2024/02/capa-penn-state.jpg.webp",
      },
      {
        img: "https://rehagro.com.br/blog/wp-content/uploads/2024/02/capa-penn-state.jpg.webp",
      },
    ],
  }),
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
  },
  mounted() {
    this.dialog = true;
  },
};
</script>

<style>
</style>